import BaseService from './BaseService';
import { Observable } from "rxjs";
import { CBlocker } from '@/components/Blocker/CBlocker';
export default class ScheduleTimeService {
    constructor() {
        this.path = 'schedules_times';
    }
    getAll(filter, order, page, length) {
        let content = Object();
        if (filter) {
            content.filter = filter;
        }
        if (order) {
            content.order = order;
        }
        if (page) {
            content.page = page;
        }
        if (length) {
            content.length = length;
        }
        return BaseService.get(this.path, content);
    }
    add(reg) {
        CBlocker.showLoading();
        return new Observable((observer) => {
            BaseService.post(this.path, reg, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Intervalo añadido');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    update(reg) {
        CBlocker.showLoading();
        let content = reg;
        return new Observable((observer) => {
            BaseService.put(this.path + '/' + reg.id, content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('¡Actualizado!');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    delete(reg) {
        CBlocker.showLoading();
        return new Observable((observer) => {
            BaseService.delete(this.path + '/' + reg.id, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Intervalo eliminado');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    getEnums(name) {
        if (ScheduleTimeService.enums.length == 0) {
            let content = {};
            if (name)
                content.name = name;
            return BaseService.get(this.path + '/enums', content);
        }
        else {
            return new Observable((observer) => {
                observer.next(ScheduleTimeService.enums);
            });
        }
    }
}
ScheduleTimeService.enums = new Array();
